export default __webpack_public_path__ + "static/media/1612860349382.d07250b6.jpg";